export const iframeStore = { iframe: null, siteDomain: null };

export function setIframe(el) {
    iframeStore.iframe = el;
}

export function getIframe() {
    return iframeStore.iframe;
}

export function setSiteDomain(origin) {
    iframeStore.siteDomain = origin;
}

export function getSiteDomain() {
    return iframeStore.siteDomain;
}